/* 账号相关 */

import request from "@/utils/request";
import axios from "axios";

import { stringify } from "qs";

export async function initialize(params) {
  axios
    .get("/api/initialize/get", {})
    .then(function(response) {
      console.log(response);
    })
    .catch(function(error) {
      console.log(error);
    });
}

/**
 * 账号密码登录
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function login(params: object) {
  return request(`/api/login?${stringify(params)}`, {});
}

/**
 * 注册
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function signUp(params: object) {
  return request(`/api/phone/user/register?${stringify(params)}`, {
    method: "POST"
  });
}

/**
 * 修改密码
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function modifyPassword(params: object) {
  return request(`/api/lostPassword`, {
    method: "POST",
    body: params
  });
}

/**
 * 发送验证码
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function vcode(params: { type: number;mobile: string,verification?:string, source?: number}) {
  return request(`/api/phone/user/send/code?${stringify(params)}`, {
    method: "POST",
    credentials:  (params.type === 1 || params.type === 5) ? 'include' : 'omit' ,
  });
}

/**
 * 绑定手机号
 * @param params
 * @returns {Promise<TResult|TResult2|TResult1>}
 */
export async function bindPhoneOrEmail(params: object) {
  return request(`/api/bindPhoneOrEmailNew`, {
    method: "POST",
    body: params
  });
}

/**
 * h5微信服务号登陆
 * @param params
 */
export async function weChatServerLogin(params: object) {
  return request(`/api/weChatServerLogin`, {
    method: "POST",
    body: params
  });
}
/**
 * h5微信服务号绑定
 * @param params
 */
export async function weChatServerBinding(params: object) {
  return request(`/api/weChatServerBinding`, {
    method: "POST",
    body: params
  });
}
/**
 * h5微信服务号解绑
 * @param params
 */
export async function weChatServerUnBinding(params: object) {
  return request(`/api/weChatServerUnBinding`, {
    method: "POST",
    body: params
  });
}
